module.exports = __webpack_public_path__ + "static/dhampir-ed19fc03f94a2f5e2cd39c6063399a63.png";